// extracted by mini-css-extract-plugin
module.exports = {"blur-background":"BlurBackground_blur-background__fWbcq","blur-effect":"BlurBackground_blur-effect__KayUH"};